import { Box, media, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { WidthObserver } from '@atlaskit/width-detector';
import { Aside } from '@atlassian/navigation-system';
import { cssMap } from '@compiled/react';
import throttle from 'lodash.throttle';
import React, { useState } from 'react';

// Use of token() is handled by atlaskit/tokens transformer, but this eslint rule is still complaining
/* eslint-disable @compiled/no-invalid-css-map */
const compiledStyles = cssMap({
  aside: {
    backgroundColor: token('elevation.surface.sunken'),
  },
});
/* eslint-enable @compiled/no-invalid-css-map */

const asideStyles = xcss({
  paddingInlineStart: 'space.300',
  paddingInlineEnd: 'space.300',
  [media.above.lg]: {
    paddingInlineStart: 'space.600',
    paddingInlineEnd: 'space.600',
  },
});

const NARROW_BREAKPOINT = 1280;
const NARROW_ASIDE_WIDTH = 300;
const DEFAULT_ASIDE_WIDTH = 400;

export const GriffinResponsiveAside = (props: { children: React.ReactNode }) => {
  const [isNarrow, setIsNarrow] = useState<boolean>(false);
  const throttledSetWidth = throttle(width => {
    setIsNarrow(width <= NARROW_BREAKPOINT);
  }, 50);

  return (
    <Aside defaultWidth={isNarrow ? NARROW_ASIDE_WIDTH : DEFAULT_ASIDE_WIDTH} xcss={compiledStyles.aside}>
      <WidthObserver setWidth={throttledSetWidth} />
      <Box xcss={asideStyles}>{props.children}</Box>
    </Aside>
  );
};
